module.exports = __webpack_public_path__ + "img/error_bg.93790fda.svg";